import { Components, Theme } from '@mui/material/styles';

export const AppBarHeight = 50;

export const appBarThemeDefinition = () =>
  ({
    MuiAppBar: {
      styleOverrides: {
        root: {
          '& .MuiToolbar-root': {
            minHeight: AppBarHeight,
            position: 'relative',
          },
        },
      },
    },
  } as Components<Theme>);
